import { createContext, use } from 'react';
import type { PublicTenant } from '../shared/public-tenant';

export type TenantContextValue = {
  tenant: PublicTenant;
  slug: string;
  /** '' на поддомене, '/s/<slug>' в режиме пути */
  basename: string;
  mode: 'subdomain' | 'path';
};

export const TenantContext = createContext<TenantContextValue | null>(null);

export function useTenant(): TenantContextValue {
  const value = use(TenantContext);
  if (!value) throw new Error('useTenant: нет TenantContext выше по дереву');
  return value;
}
